<template>
    <div class="page-country" ref="page">
        <div class="container">
            <div class="page-country-left">
                <a href="#" @click.prevent="toMap" class="back-link">
                    <p>Вернуться к карте мира</p>
                </a>

                <div class="page-country-left-bg" :class="{ 'close-map' : closeMapHead }"   v-for="country in countries" v-if="country.name == routeName" >

                    <div class="mobile-country-inner">
                        <div class="map-img-background" v-if="closeMapHead && $root.isMobile"></div>
                        <img class="map-img" :src="countries[routeName].img" alt="" :class="{ 'img-israel' : countries[routeName].name =='israel' }">

                        <div class="mobile-dots" v-if="$root.isMobile">
                            <a href="#" :style="country.items[index].position_mobile" @click.prevent="placesClickMobile(index,places.city)" class="dot-places"  v-for="(places, index) in country.items">
                                <dot class="dot"></dot>
                            </a>
                        </div>
                    </div>


                    <a href="#" :style="country.items[index].position" @click.prevent="placesClick(index,places.city)" class="dot-places"  v-for="(places, index) in country.items" v-if="!$root.isMobile">
                        <dot class="dot"></dot>
                    </a>




                    <a href="#" @click.prevent="closeMap" class="map-close" v-if="$root.isMobile">
                    <close></close>
                    <p>{{ closeMapHead ? 'Открыть' : 'Закрыть' }} тепловую карту</p>
                    </a>
                </div>
            </div>
            <div class="page-country-right"  v-for="(country,index) in countries" v-if="country.name == routeName">
                <div class="country-slider">

                    <div class="image-top-box">
                        <div class="image-top-main">
                            <img :src="countries[routeName].items[currentIndex].img" alt="">
                        </div>

                        <div class="buttons-inner">
                            <div class="button-left" @click.prevent="prevPlace">
                                <img src="/static/images/country/arrow.png" alt="">
                            </div>
                            <div class="button-right" @click.prevent="nextPlace">
                                <img src="/static/images/country/arrow.png" alt="">
                            </div>
                        </div>
                        <div class="image-top-text">
                            <span >{{country.title}} | {{ countries[routeName].items[currentIndex].city }}</span>
                            <h2>{{ country.items[currentIndex].name }}</h2>
                            <p class="main-text">{{ country.items[currentIndex].text }}</p>
                            <p class="description">{{ country.items[currentIndex].description }}</p>
                            <!--<div class="address">
                                <a href="">
                                    <div class="pin">
                                        <pin></pin>
                                    </div>
                                    <p>{{ country.items[currentIndex].address }}</p>
                                </a>
                            </div>-->
                        </div>

                    </div>

                    <div class="image-bottom-box">
                        <h3>Хочешь сделать фото из необычного места?</h3>
                        <p class="bottom-text">Смотри места, которые мы подобрали:</p>
                        <div class="items">
                            <div class="item" v-for="(places, index) in country.items" :key="index">
                                <a @click.prevent="placesClickMore(index,places.city)" href="#">
                                <img :src="places.img" alt="" v-if="!$root.isMobile">
                                <img :src="places.img_mobile" alt="" v-else>
                                </a>
                                <h4>{{ places.name }}</h4>
                                <a class="btn-more" @click.prevent="placesClickMore(index,places.city)" href="#">Подробнее</a>
                            </div>
                        </div>
                        <div class="snapshot-box">
                            <h5>Снимки в режиме 24/7</h5>
                            <p>Где&nbsp;бы ты&nbsp;не&nbsp;был, с&nbsp;роумингом от&nbsp;МегаФона ты&nbsp;можешь не&nbsp;думать
                                о&nbsp;ценах на&nbsp;роуминг. Фотографируй все что хочешь, выкладывай в&nbsp;сеть, делись своими находками с&nbsp;друзьями, и&nbsp;продолжай искать самые фотогеничные места мира. Ведь МегаФон предлагает услуги связи
                                по&nbsp;домашним ценам в&nbsp;путешествиях по&nbsp;миру.</p>
                            <span>Стоимость операции - 299 рублей в сутки</span>
                            <a target="_blank" href="https://www.megafon.ru/go/roaming_goodbye?utm_source=afisha&utm_campaign=fed_flight_www-b2c_afisha-special-project-roaming-goodbye-2-jul-2018_rf&utm_medium=ag-media_media_promo-block_text_cpc__&utm_content=&utm_term" class="btn btn-connect" @click="gaSend('Button connect')">Подключить</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TweenMax, TweenLite} from 'gsap'
    import ScrollToPlugin from "gsap/ScrollToPlugin"
    import Helpers from '@/tools/Helpers'


    import  {items}  from '@/tools/Country';
    import pin from '@/assets/svg/pin.svg'
    import close from '@/assets/svg/close-map.svg'
    import dot from '@/assets/svg/dot.svg'

    export default {
        name: 'Main',
        components: {
            pin,
            close,
            dot
        },
        data() {
            return {
                currentIndex: 0,
                closeMapHead: true
            }
        },
        computed: {
            routeName() {
                return this.$route.params.name

            },
            countries() {
                return items
            }
        },
        methods: {
            gaSend(index) {
                Helpers.ga().send( 'Country inner page', 'Click', index);
            },
            prevPlace() {
                this.toggleActivePlace( Math.min(this.countries[this.routeName].items.length,Math.max(0, this.currentIndex-1)));
            },
            nextPlace() {
                this.toggleActivePlace( Math.min(this.countries[this.routeName].items.length-1,Math.max(0, this.currentIndex+1)));
            },
            closeMap() {
                this.closeMapHead = !this.closeMapHead
            },
            toMap() {
                this.$router.push('/');
            },
            placesClick(index,city) {
                this.toggleActivePlace(index);
                Helpers.ga().send( 'Country inner page', 'Click', city);
            },
            placesClickMore(index,city) {
                this.toggleActivePlace(index);
                Helpers.ga().send( 'Country inner page', 'Click', city);
            },
            placesClickMobile(index, city) {
                Helpers.ga().send( 'Country inner page', 'Click', city);
                for (let item in this.countries) {
                    if (this.countries[item].name == this.routeName) {
                        for (let i = 0; i < this.countries[item].items.length; i++) {
                            this.countries[item].items[i].isActive = false;
                        }
                        this.countries[item].items[index].isActive = true;
                        this.currentIndex = index;
                    }
                }

                TweenLite.to('#app', 1, {scrollTo: '.page-country-right'});
            },
            toggleActivePlace(index) {
                for (let item in this.countries) {
                    if (this.countries[item].name == this.routeName) {
                        for (let i = 0; i < this.countries[item].items.length; i++) {
                            this.countries[item].items[i].isActive = false;
                        }
                        this.countries[item].items[index].isActive = true;
                        this.currentIndex = index;
                    }
                }

                !this.$root.isMobile ? TweenLite.to('.country-slider', 1, {scrollTo: 0}) : TweenLite.to('#app', 1, {scrollTo: 0});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Country.vue?1d676502